module.exports = {
      id: "42f8088a2f089a2835760dac1939f80croofShape-saddle-with-dormers.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#42f8088a2f089a2835760dac1939f80croofShape-saddle-with-dormers.svg",
      toString: function () {
        return this.url;
      }
    }